<template>
  <div class="live">
    <div class="live">
      <div class="title">{{ $t('homePage.activity.title') }}</div>
      <div id="swiper-tt" class="exhibitorsLive">
        <!-- 轮播开始 -->

        <!-- swiper -->
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in lunItem" :key="index">
            <div class="card" @click="goDetail(item.id)">
              <div class="backImg">
                <img :src="item.backImgUrl" alt="" v-if="item.backImgUrl.substr(0, 4) == 'http'"/>
                <img :src="baseUrl + item.backImgUrl" alt="" v-else/>
                <span class="bottomImg" @click.stop="collection(item,4)">
									<img v-if="item.collectStatus" alt="" src="../../static/collent_yello.png"/><!--显示金色-->
									<img v-else alt="" src="../../static/collent.png"/><!--显示无色-->
								</span>
              </div>
              <div class="box">
                <div class="text">{{ item.videoTitle }}</div>
                <div class="date">
                  <div class="img">
                    <img alt="" src="../../static/ico_time.png"/>
                  </div>
                  <span>{{ item.date }}</span>
                </div>

                <div class="address">
                  <div class="img">
                       <img alt="" src="../../static/ico_address.png"/>
                  </div>
                  <span class="zhanweihao">{{ $t('activity.place') }}</span>
                  <span class="number">{{ item.address }}</span>
                </div>

                <div class="company">{{ item.company }}</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <!-- 分页 数据大于4条时出现-->
        <div v-if="lunItem.length>4" slot="pagination" class="swiper-page"></div>
        <!-- 轮播结束 -->
      </div>

      <!--查看更多-->
      <router-link to="active">
        <div class="lookMore">{{ $t('common.viewMore') }}</div>
      </router-link>

    </div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import {getActivities} from "../../../api/homePage";
import {forMat} from "../../../utils/common";

export default {
  name: 'exhibitorsLive',
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      //swiper 初始化
      swiperOption: {
        // loop: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        loopFillGroupWithBlank: true,
        spaceBetween: 31,
        autoplay: {
          delay: 7000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: '.swiper-page',
          clickable: true, //允许分页点击跳转
          bulletActiveClass: 'my-bullet-active',
        },
        // 设置点击箭头
        navigation: {
          nextEl: '#swiper-top .swiper-button-prev',
          prevEl: '#swiper-top .swiper-button-prev',
        },
      },

      //轮播子元素
      lunItem: [
        {
          backImgUrl: require('../../static/占位-展商-详情.png'),
          videoTitle: '直播内容',
          date: '2021-11-24',
          videoTime: '10:00直播',
          company: '中科万互联网技术有限公司',
        }
      ],
      //收藏按钮
      collent_toggle: false,
      baseUrl: forMat()
    };
  },
  methods: {
    async getActivities() {
      try {
        let {data} = await getActivities()
        this.lunItem = data.data.list.map((item, i) => {
          let lunItem = {
            backImgUrl: item.column15,      //活动封面
            videoTitle: item.actTitle,               //活动名称中文
            date: item.startTime,                   //开始时间
            company: item.hzExhibitor.companyNameC, //展商名称
            address: item.address,
            id: item.id,
            collectStatus: item.collectStatus,
          }
          return lunItem
        })
      } catch (e) {
        console.log(e)
      }
    },

    collection(item, type) {
      this.$parent.collection(item, type)
    },

    //跳转至详情
    goDetail(id) {
      this.$router.push({
        name: 'active_detail',
        query: {
          id
        },
      });
    }
  },
  created() {
    this.getActivities()
  }
};
</script>
<style lang="scss" scoped>
.live {
  width: 100%;
  height: fit-content;
  // border: 1px solid red;
  .title {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding-top: 59px;
    padding-bottom: 52px;
    box-sizing: border-box;
  }

  .exhibitorsLive {
    width: 1294px;      //加6*4px是因为轮播内容要有左边距才能在移入时左侧显示出阴影
    margin: 0 auto;
    height: 450px;      //
    background-color: white !important;

    .swiper-slide {
      height: 450px;

      .card {
        background-color: white !important;
        cursor: pointer;
        width: 295px;
        margin: 3px 3px 0;//外边距加3px显示卡片阴影
        transition: all .3s ;
        &:hover {
          box-shadow:0px 0px 3px #9fa3a5;
          .box .text {
            color: #006FB8;
          }
        }

        .backImg {
          box-sizing: border-box;
          width: 100%;
          height: 190px;


          img {
            width: 100%;
            height: 100%;
          }

          .bottomImg {
            position: absolute;
            right: 12px;
            top: 12px;
            z-index: 3;

            span {
              width: 30px;
              height: 29px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .box {
          border-left: 1px solid #e0e0e0;
          border-right: 1px solid #e0e0e0;
          border-bottom: 1px solid #e0e0e0;

          .text {
            width: 237px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            margin: 0 auto;
            padding-top: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            height: 42px;
            transition: all .3s;
          }

          .date {
            width: 237px;
            margin: 0 auto;
            margin-top: 15px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .img {
              width: 24px;
              height: 24px;

              img {
                width: 24px;
                height: 24px;
              }
            }

            span {
              margin-left: 6px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
          /*     color: #fdd000; */
               color: #666666;
            }
          }

          .address {
            width: 257px;
            min-height: 48px;
            // border: 1px solid red;
            margin-right: 10px !important;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 0 auto;
            padding-top: 7px;
            margin-top: 7px;

            .img {
              width: 24px;
              height: 24px;
            }

            span {
              margin-left: 6px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
            }
            .zhanweihao{
              white-space: nowrap;
            }
            .number {
           /*    color: #fdd000; */
            /*   font-weight: 600; */
              font-size: 16px;
              color: #666666;
            }
          }

          .company {
            margin: 0 auto;
            padding: 0px 15px;
            border-top: 1px solid #E0E0E0;
            height: 56px;
            margin-top: 19px;

            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 55px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }

  a {
    display: block;
    text-decoration: none;

    .lookMore {
      width: 247px;
      height: 44px;
      border: 1px solid #333333;
      border-radius: 4px;
      margin: 0 auto;
      text-align: center;
      line-height: 44px;
      margin-top: 80px;
      margin-bottom: 100px;
      color: #333333;
      font-size: 16px;
    }
  }
}
</style>
<style scoped>
/*-------------------轮播图样式修改---------------------------*/
.swiper-slide {
  width: 200px;
  height: 374px;
  /* background-color: #2ea9e2 !important; */
}

/* 修改轮播元素的尺寸 */
.swiper-page {
  height: 10px;
  width: 74px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  position: static !important;
  margin-top: 31px;
}

/* 修改轮播图指示点的样式 */
/*.swiper-page swiper-pagination-clickable swiper-pagination-bullets >>> .swiper-pagination-bullet-active {*/
/*	background-color: #fccf00 !important;*/
/*}*/
/* 
>>> .swiper-pagination-bullet.my-bullet-active {
  background: #fccf00 !important;
  opacity: 1;
} */
</style>
